import Passage from './Passage';
export default Passage;